export const HEADER_BREAK_POINT = 1170 // must be same as $header-break-point scss variable in _variables.scss + padding (2 x 10px)
